import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './components/ThemeProvider.tsx'
import { PrerenderDataProvider } from './PrerenderDataContext.tsx'
import { I18nProvider } from './i18n/I18nContext.tsx'
import { initPostHog } from './analytics/posthog.ts'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

if (!GOOGLE_CLIENT_ID && import.meta.env.DEV) {
  console.error('[main] Missing VITE_GOOGLE_CLIENT_ID environment variable');
}

// Initialize analytics as early as possible, but only when enabled.
initPostHog();

// Chunk de um build antigo (deploy a meio da sessão de alguém): o Vite dispara
// vite:preloadError quando um dynamic import falha. Em vez de deixar a app
// partida no ecrã, recarrega uma vez — o index.html novo (no-cache) traz os
// chunks certos. O guard evita um loop de reloads se o problema persistir.
let chunkReloaded = false;
window.addEventListener('vite:preloadError', () => {
  if (chunkReloaded) return;
  chunkReloaded = true;
  window.location.reload();
});

const initialData = window.__KARAOKR_INITIAL_DATA__ ?? {};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PrerenderDataProvider data={initialData}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <I18nProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </I18nProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </PrerenderDataProvider>
  </StrictMode>,
)
